import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "app-auth-button",
  templateUrl: "./auth-button.component.html",
  styleUrls: ["./auth-button.component.scss"],
})
export class AuthButtonComponent {
  @Input()
  public buttonText: string;

  @Input()
  public parentForm: UntypedFormGroup;
}
